import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import globals from '@/globals';
import Layout2 from '@/layout/Layout2';
import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav';
import AuthenticationLoginV2 from '@/layout/AuthenticationLoginV2';
import IntegratedAuthentication from '@/layout/IntegratedAuthentication';
import PageNotFound from '@/layout/PageNotFound';
import store from '../store';
import mfaRequiredRoutes from './mfaRequiredRoutes';
import rootRequiredRoutes from './rootRequiredRoutes';

Vue.use(Router);
Vue.use(Meta);

const layout = {
  menu: {
    horizontal: LayoutHorizontalSidenav,
    vertical: Layout2,
    default: LayoutHorizontalSidenav
  }
};

const configUser =
  store.state.user.info && store.state.user.info.orientacao_menu
    ? store.state.user.info.orientacao_menu
    : 'vertical';

const getUserIsRoot = store.state.user?.info?.root || false;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: AuthenticationLoginV2,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.authenticated) {
          next('/dashboard');
        } else {
          next();
        }
      }
    },
    {
      path: '/login/integrated',
      component: IntegratedAuthentication
    },
    {
      path: '/dashboard',
      beforeEnter: (to, from, next) => {
        if (store.state.auth.authenticated) {
          next();
        } else {
          next('/');
        }
      },
      get component() {
        return configUser && layout.menu[configUser] ? layout.menu[configUser] : layout.menu['default'];
      },
      children: [
        {
          path: '',
          component: () => import('@/components/views/Dashboard')
        },
        {
          path: '/dashboardMetabase',
          component: () => import('@/components/views/MetabaseDashboard')
        },
        {
          path: '/sobre',
          component: () => import('@/components/views/Sobre')
        },
        {
          path: '/empresa/configuracao',
          component: () => import('@/components/views/menu/ConfigEmpresa')
        },
        {
          path: '/tema',
          component: () => import('@/components/views/menu/TrocarTema.vue')
        },
        {
          path: '/suporte/alertas/listar',
          component: () => import('@/components/views/menu/suporte/alertas/ListagemAlertas')
        },
        {
          path: '/suporte/notas/listar',
          component: () => import('@/components/views/menu/suporte/notas/ListagemNotasVersao')
        },
        {
          path: '/suporte/tickets/listar',
          component: () => import('@/components/views/menu/suporte/tickets/ListagemTickets')
        },
        {
          path: '/suporte/tickets/cadastrar',
          name: 'cadastrarTicket',
          component: () => import('@/components/views/menu/suporte/tickets/FormularioTickets'),
          props: true
        },
        {
          path: '/suporte/tickets/alterar/:id',
          name: 'editarTicket',
          component: () => import('@/components/views/menu/suporte/tickets/FormularioTickets')
        },
        {
          path: '/principal/cadastros/centroDeCusto/listar',
          name: 'listarCentroDeCusto',
          component: () => import('@/components/views/principal/cadastros/centroDeCusto/ListagemCentroDeCusto')
        },
        {
          path: '/principal/cadastros/centroDeCusto/cadastrar',
          name: 'criarCentroDeCusto',
          component: () => import('@/components/views/principal/cadastros/centroDeCusto/FormularioCentroDeCusto'),
          props: true
        },
        {
          path: '/principal/cadastros/centroDeCusto/alterar/:id',
          name: 'editarCentroDeCusto',
          component: () => import('@/components/views/principal/cadastros/centroDeCusto/FormularioCentroDeCusto')
        },

        {
          path: '/principal/cadastros/tipoDespesa/listar',
          name: 'listarTipoDespesa',
          component: () => import('@/components/views/principal/cadastros/tipoDespesa/ListagemTipoDespesa')
        },
        {
          path: '/principal/cadastros/tipoDespesa/cadastrar',
          name: 'criarTipoDespesa',
          component: () => import('@/components/views/principal/cadastros/tipoDespesa/FormularioTipoDespesa'),
          props: true
        },
        {
          path: '/principal/cadastros/tipoDespesa/alterar/:id',
          name: 'editarTipoDespesa',
          component: () => import('@/components/views/principal/cadastros/tipoDespesa/FormularioTipoDespesa')
        },
        {
          path: '/relatorios/financeiro/movimentoDetalhado',
          name: 'relatorioFinanceiroKioskatm',
          component: () => import('@/components/views/relatorios/financeiro/Kioskatm')
        },
        {
          path: '/relatorios/financeiro/movimentoAgrupado',
          name: 'relatorioFinanceiroATMAgrupado',
          component: () => import('@/components/views/relatorios/financeiro/KioskATMAgrupado')
        },
        {
          path: '/principal/cadastros/localidade/listar',
          name: 'listarLocalidade',
          component: () => import('@/components/views/principal/cadastros/localidade/ListagemLocalidade')
        },
        {
          path: '/principal/cadastros/secao/listar',
          name: 'listarSecao',
          component: () => import('@/components/views/principal/cadastros/secao/ListagemSecao')
        },
        {
          path: '/principal/cadastros/secao/alterar/:id',
          name: 'editarSecao',
          component: () => import('@/components/views/principal/cadastros/secao/FormularioSecao')
        },
        {
          path: '/principal/cadastros/secao/cadastrar',
          name: 'criarSecao',
          component: () => import('@/components/views/principal/cadastros/secao/FormularioSecao'),
          props: true
        },
        {
          path: '/principal/cadastros/usuario/listar',
          name: 'listarUsuarios',
          component: () => import('@/components/views/principal/cadastros/usuario/ListagemUsuario')
        },
        {
          path: '/principal/cadastros/arrecadador/listar',
          name: 'listarUsuarioArrecadador',
          component: () =>
            import('@/components/views/principal/cadastros/usuarioArrecadador/ListagemUsuarioArrecador')
        },
        {
          path: '/principal/cadastros/arrecadador/alterar/:id',
          name: 'editarUsuarioArrecadador',
          component: () =>
            import('@/components/views/principal/cadastros/usuarioArrecadador/FormularioUsuarioArrecadador')
        },
        {
          path: '/principal/cadastros/arrecadador/cadastrar/',
          name: 'cadastrarUsuarioArrecadador',
          component: () =>
            import('@/components/views/principal/cadastros/usuarioArrecadador/FormularioUsuarioArrecadador')
        },
        {
          path: '/principal/cadastros/usuario/alterar/:id',
          name: 'editarUsuario',
          component: () => import('@/components/views/principal/cadastros/usuario/FormularioUsuario')
        },
        {
          path: '/principal/cadastros/usuario/cadastrar',
          name: 'criarUsuario',
          component: () => import('@/components/views/principal/cadastros/usuario/FormularioUsuario'),
          props: true
        },
        {
          path: '/principal/cadastros/localidade/cadastrar',
          name: 'criarLocalidade',
          component: () => import('@/components/views/principal/cadastros/localidade/FormularioLocalidade'),
          props: true
        },
        {
          path: '/principal/cadastros/localidade/alterar/:id',
          name: 'editarLocalidade',
          component: () => import('@/components/views/principal/cadastros/localidade/FormularioLocalidade')
        },
        {
          path: '/principal/cadastros/perfil/riscoPorTipo',
          name: 'riscoPorTipo',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/riscoPorTipo/ListagemRiscoPorTipo.vue')
        },
        {
          path: '/principal/cadastros/perfil/riscoPorTipo/form',
          name: 'riscoPorTipoFormulario',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/riscoPorTipo/FormularioRiscoPorTipo.vue')
        },
        {
          path: '/principal/cadastros/rota/listar',
          name: 'listarRotas',
          component: () => import('@/components/views/principal/cadastros/rota/ListagemRota')
        },
        {
          path: '/principal/cadastros/rota/cadastrar',
          name: 'criarRota',
          component: () => import('@/components/views/principal/cadastros/rota/FormularioRota'),
          props: true
        },
        {
          path: '/principal/cadastros/rota/alterar/:id',
          name: 'editarRota',
          component: () => import('@/components/views/principal/cadastros/rota/FormularioRota')
        },
        {
          path: '/principal/cadastros/servico/listar',
          name: 'listarServicos',
          component: () => import('@/components/views/principal/cadastros/servico/ListagemServicos')
        },
        {
          path: '/principal/cadastros/servico/cadastrar',
          name: 'criarServico',
          component: () => import('@/components/views/principal/cadastros/servico/FormularioServico')
        },
        {
          path: '/principal/cadastros/servico/alterar/:id',
          name: 'editarServico',
          component: () => import('@/components/views/principal/cadastros/servico/FormularioServico')
        },
        {
          path: '/principal/cadastros/circular/listar',
          name: 'listarCircular',
          component: () => import('@/components/views/principal/cadastros/circular/ListagemCircular')
        },
        {
          path: '/principal/cadastros/circular/cadastrar',
          name: 'criarCircular',
          component: () => import('@/components/views/principal/cadastros/circular/FormularioCircular'),
          props: true
        },
        {
          path: '/principal/cadastros/circular/alterar/:id',
          name: 'editarCircular',
          component: () => import('@/components/views/principal/cadastros/circular/FormularioCircular')
        },
        {
          path: '/principal/cadastros/controle/usuario',
          name: 'controleUsuario',
          component: () =>
            import('@/components/views/principal/cadastros/controle/usuario/ListagemControleUsuario')
        },
        {
          path: '/principal/cadastros/controle/serialReport',
          name: 'controleTerminal',
          component: () =>
            import('@/components/views/principal/cadastros/controle/terminal/ListagemControleTerminal')
        },
        {
          path: '/principal/cadastros/estabelecimento/listar',
          name: 'listarEstabelecimento',
          component: () => import('@/components/views/principal/cadastros/estabelecimento/ListagemEstabelecimento')
        },
        {
          path: '/principal/cadastros/estabelecimento/formulario',
          name: 'criarEstabelecimento',
          component: () =>
            import('@/components/views/principal/cadastros/estabelecimento/FormularioEstabelecimento'),
          props: true
        },
        {
          path: '/principal/cadastros/estabelecimento/cadastroRapido',
          name: 'cadastroRapidoEstabelecimento',
          component: () =>
            import(
              '@/components/views/principal/cadastros/estabelecimento/components/CadastroRapidoEstabelecimento.vue'
            ),
          props: true
        },
        {
          path: '/principal/cadastros/cadastroIntegrado/alterar/:id',
          name: 'editarCadastroIntegrado',
          component: () =>
            import('@/components/views/principal/cadastros/cadastroIntegrado/FormularioCadastroIntegrado.vue'),
          props: true
        },
        {
          path: '/principal/cadastros/estabelecimento/alterar/:id',
          name: 'editarEstabelecimento',
          component: () =>
            import('@/components/views/principal/cadastros/estabelecimento/FormularioEstabelecimento'),
          props: true
        },
        {
          path: '/principal/cadastros/gestor/listar',
          name: 'listarGestor',
          component: () => import('@/components/views/principal/cadastros/gestor/ListagemGestor')
        },
        {
          path: '/principal/cadastros/gestor/cadastrar',
          name: 'criarGestor',
          component: () => import('@/components/views/principal/cadastros/gestor/FormularioGestor'),
          props: true
        },
        {
          path: '/principal/cadastros/gestor/alterar/:id',
          name: 'editarGestor',
          component: () => import('@/components/views/principal/cadastros/gestor/FormularioGestor')
        },
        {
          path: '/principal/cadastros/perfil/competicao/listar',
          name: 'listarPerfilCompeticao',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/competicao/ListagemPerfilCompeticao')
        },
        {
          path: '/principal/gerencia/configuracao/prioridadeCompeticao/listar',
          name: 'listarPrioridadeCompeticao',
          component: () =>
            import(
              '@/components/views/principal/gerencia/configuracao/prioridadeCompeticao/ListagemPrioridadeCompeticao'
            )
        },
        {
          path: '/principal/gerencia/configuracao/prioridadeCompeticao/cadastrar',
          name: 'cadastrarPrioridadeCompeticao',
          component: () =>
            import(
              '@/components/views/principal/gerencia/configuracao/prioridadeCompeticao/FormularioPrioridadeCompeticao'
            ),
          props: true
        },
        {
          path: '/principal/gerencia/configuracao/prioridadeCompeticao/alterar/:id',
          name: 'editarPrioridadeCompeticao',
          component: () =>
            import(
              '@/components/views/principal/gerencia/configuracao/prioridadeCompeticao/FormularioPrioridadeCompeticao'
            ),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/competicao/cadastrar',
          name: 'cadastrarPerfilCompeticao',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/competicao/FormularioPerfilCompeticao'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/competicao/alterar/:id',
          name: 'editarPerfilCompeticao',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/competicao/FormularioPerfilCompeticao')
        },
        {
          path: '/principal/cadastros/perfil/bonusUsuario/listar',
          name: 'listarPerfilBonusUsuario',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/bonusUsuario/ListagemPerfilBonusUsuario')
        },
        {
          path: '/principal/cadastros/perfil/bonusUsuario/cadastrar',
          name: 'cadastrarPerfilBonusUsuario',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/bonusUsuario/FormularioPerfilBonusUsuario'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/bonusUsuario/alterar/:id',
          name: 'editarPerfilBonusUsuario',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/bonusUsuario/FormularioPerfilBonusUsuario'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/limitePadrao/listar',
          name: 'listarLimitePadrao',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/limitePadrao/ListagemLimitePadrao')
        },
        {
          path: '/principal/cadastros/perfil/limitePadrao/cadastrar',
          name: 'cadastrarLimitePadrao',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/limitePadrao/FormularioLimitePadrao'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/limitePadrao/alterar/:id',
          name: 'editarLimitePadrao',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/limitePadrao/FormularioLimitePadrao')
        },
        {
          path: '/principal/cadastros/perfil/comissao/listar',
          name: 'listarPerfilComissao',
          component: () => import('@/components/views/principal/cadastros/perfil/comissao/ListagemPerfilComissao')
        },
        {
          path: '/principal/cadastros/perfil/comissao/cadastrar',
          name: 'cadastrarComissaoPerfil',
          component: () => import('@/components/views/principal/cadastros/perfil/comissao/FormularioPerfil'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/:id/comissao/alterar',
          name: 'editarComissaoPerfil',
          component: () => import('@/components/views/principal/cadastros/perfil/comissao/FormularioPerfil'),
          props: true
        },

        // Affiliate system (SYSA) routes

        //marcas (sysa.brand)
        {
          path: '/principal/afiliados/marcas/listar',
          name: 'listarMarcasSysa',
          component: () => import('@/components/views/principal/afiliados/brand/BrandList')
        },
        {
          path: '/principal/afiliados/marcas/alterar/:id',
          name: 'alterarMarcasSysa',
          component: () => import('@/components/views/principal/afiliados/brand/BrandForm'),
          props: true
        },
        {
          path: '/principal/afiliados/marcas/cadastrar',
          name: 'cadastrarMarcasSysa',
          component: () => import('@/components/views/principal/afiliados/brand/BrandForm')
        },
        //campanhas (sysa.campaign)
        {
          path: '/principal/afiliados/campanhas/listar',
          name: 'listarCampanhasSysa',
          component: () => import('@/components/views/principal/afiliados/campaign/CampaignList')
        },
        {
          path: '/principal/afiliados/campanhas/alterar/:id',
          name: 'alterarCampaignSysa',
          component: () => import('@/components/views/principal/afiliados/campaign/CampaignForm'),
          props: true
        },
        {
          path: '/principal/afiliados/campanhas/cadastrar',
          name: 'cadastrarCampaignSysa',
          component: () => import('@/components/views/principal/afiliados/campaign/CampaignForm')
        },
        //afiliados (sysa.affiliate)
        {
          path: '/principal/afiliados/afiliados/listar',
          name: 'listarAfiliadosSysa',
          component: () => import('@/components/views/principal/afiliados/affiliate/AffiliateList')
        },
        {
          path: '/principal/afiliados/afiliados/alterar/:id',
          name: 'alterarAfiliadosSysa',
          component: () => import('@/components/views/principal/afiliados/affiliate/AffiliateForm'),
          props: true
        },
        {
          path: '/principal/afiliados/afiliados/cadastrar',
          name: 'cadastrarAfiliadosSysa',
          component: () => import('@/components/views/principal/afiliados/affiliate/AffiliateForm')
        },
        //actions (sysa.action)
        {
          path: '/principal/afiliados/acoes/listar',
          name: 'listarActionsSysa',
          component: () => import('@/components/views/principal/afiliados/action/ActionList')
        },
        {
          path: '/principal/afiliados/acoes/alterar/:id',
          name: 'alterarActionsSysa',
          component: () => import('@/components/views/principal/afiliados/action/ActionForm'),
          props: true
        },
        {
          path: '/principal/afiliados/acoes/cadastrar',
          name: 'cadastrarActionsSysa',
          component: () => import('@/components/views/principal/afiliados/action/ActionForm')
        },
        // FIM Affiliate system (SYSA) routes

        {
          path: '/principal/cadastros/perfil/usuarioApostador/listar',
          name: 'listarPerfilUsuarioApostador',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/usuarioApostador/ListagemUsuarioApostador')
        },
        {
          path: '/principal/cadastros/perfil/usuarioApostador/cadastrar',
          name: 'cadastrarPerfilUsuarioApostador',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/usuarioApostador/FormularioUsuarioApostador'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/usuarioApostador/alterar/:id',
          name: 'editarPerfilUsuarioApostador',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/usuarioApostador/FormularioUsuarioApostador')
        },
        {
          path: '/principal/cadastros/terminal/listar',
          name: 'listarTerminalSP',
          component: () => import('@/components/views/principal/cadastros/terminal/ListagemTerminalSP.vue')
        },
        {
          path: '/principal/cadastros/terminal/cadastrar',
          name: 'cadastrarTerminalSP',
          component: () => import('@/components/views/principal/cadastros/terminal/FormularioTerminalSP.vue')
        },
        {
          path: '/principal/cadastros/terminal/editar/:id',
          name: 'editarTerminalSP',
          component: () => import('@/components/views/principal/cadastros/terminal/FormularioTerminalSP.vue')
        },
        {
          path: '/principal/cadastros/terminal/integrar',
          name: 'integrarTerminal',
          component: () =>
            import('@/components/views/principal/cadastros/cadastroIntegrado/FormularioIntegracaoTerminal.vue')
        },
        {
          path: '/principal/bilhetes/cancelamento',
          name: 'listarBilhetesCancelamento',
          component: () => import('@/components/views/principal/bilhetes/CancelamentoBilhete')
        },
        {
          path: '/principal/bilhetes/listagem',
          name: 'listarBilhetes',
          component: () => import('@/components/views/principal/bilhetes/ListagemBilhete')
        },
        {
          path: '/principal/bilhetes/devolucoes',
          name: 'listarBilhetesDevolucoes',
          component: () => import('@/components/views/principal/bilhetes/BilhetesDevolucao')
        },
        {
          path: '/principal/bilhetes/premiados',
          name: 'listarBilhetesPremiados',
          component: () => import('@/components/views/principal/bilhetes/BilhetePremiado')
        },
        {
          path: '/principal/sites/depositos',
          component: () => import('@/components/views/principal/sites/ListagemDeposito')
        },
        {
          path: '/principal/sites/cadastrosInvalidos',
          name: 'listarCadastrosInvalidos',
          component: () => import('@/components/views/principal/sites/cadastroInvalido/ListagemCadastroInvalido')
        },
        {
          path: '/principal/sites/saques',
          name: 'relatorioSitesSaques',
          component: () => import('@/components/views/principal/sites/Saques')
        },
        {
          path: '/monitor/sistema/logs/listar',
          component: () => import('@/components/views/monitor/sistema/logs/ListagemLog')
        },
        {
          path: '/monitor/sistema/alertas/listar',
          component: () => import('@/components/views/monitor/sistema/alertas/Alertas')
        },
        {
          path: '/monitor/sistema/mensagens/listar',
          name: 'listarMensagem',
          component: () => import('@/components/views/monitor/sistema/mensagens/ListagemMensagens')
        },
        {
          path: '/monitor/sistema/mensagens/cadastrar',
          name: 'criarMensagem',
          component: () => import('@/components/views/monitor/sistema/mensagens/FormularioMensagens'),
          props: true
        },
        {
          path: '/monitor/sistema/mensagens/alterar/:id',
          name: 'editarMensagem',
          component: () => import('@/components/views/monitor/sistema/mensagens/FormularioMensagens')
        },
        {
          path: '/internalProvider/evento/cadastrar',
          name: 'cadastrarEventoInternalProvider',
          component: () => import('@/components/views/internalProvider/evento/FormularioEvento.vue')
        },
        {
          path: '/internalProvider/evento/alterar/:id',
          name: 'editarEventoInternalProvider',
          component: () => import('@/components/views/internalProvider/evento/FormularioEvento.vue')
        },
        {
          path: '/internalProvider/modalidade/listar',
          name: 'listarModalidadeInternalProvider',
          component: () => import('@/components/views/internalProvider/modalidade/ListagemModalidade.vue')
        },
        {
          path: '/internalProvider/modalidade/cadastrar',
          name: 'cadastrarModalidadeInternalProvider',
          component: () => import('@/components/views/internalProvider/modalidade/FormularioModalidade.vue')
        },
        {
          path: '/internalProvider/modalidade/alterar/:id',
          name: 'editarModalidadeInternalProvider',
          component: () => import('@/components/views/internalProvider/modalidade/FormularioModalidade.vue')
        },
        {
          path: '/internalProvider/evento/listar',
          name: 'listarEventoInterno',
          component: () => import('@/components/views/internalProvider/evento/ListagemEvento')
        },
        {
          path: '/monitor/grupoLocalidade/listar',
          name: 'listarGrupoLocalidade',
          component: () => import('@/components/views/monitor/cadastros/grupoLocalidade/ListagemGrupoLocalidade')
        },
        {
          path: '/principal/cadastros/metabase_dashboard/listar',
          name: 'listarMetabaseDashboard',
          component: () => import('@/components/views/metabase/metabaseDashboard/ListagemMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/metabase_dashboard/cadastrar',
          name: 'cadastrarMetabaseDashboard',
          component: () => import('@/components/views/metabase/metabaseDashboard/FormularioMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/metabase_dashboard/editar/:id',
          name: 'editarMetabaseDashboard',
          component: () => import('@/components/views/metabase/metabaseDashboard/FormularioMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/layout_metabase_dashboard/listar',
          name: 'listarLayoutMetabaseDashboard',
          component: () =>
            import('@/components/views/metabase/layoutMetabaseDashboard/ListagemLayoutMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/layout_metabase_dashboard/cadastrar',
          name: 'cadastrarLayoutMetabaseDashboard',
          component: () =>
            import('@/components/views/metabase/layoutMetabaseDashboard/FormularioLayoutMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/layout_metabase_dashboard/editar/:id',
          name: 'editarLayoutMetabaseDashboard',
          component: () =>
            import('@/components/views/metabase/layoutMetabaseDashboard/FormularioLayoutMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/perfil_metabase_dashboard/listar',
          name: 'listarPerfilMetabaseDashboard',
          component: () =>
            import('@/components/views/metabase/perfilMetabaseDashboard/ListagemPerfilMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/perfil_metabase_dashboard/cadastrar',
          name: 'cadastrarPerfilMetabaseDashboard',
          component: () =>
            import('@/components/views/metabase/perfilMetabaseDashboard/FormularioPerfilMetabaseDashboard.vue')
        },
        {
          path: '/principal/cadastros/perfil_metabase_dashboard/editar/:id',
          name: 'editarPerfilMetabaseDashboard',
          component: () =>
            import('@/components/views/metabase/perfilMetabaseDashboard/FormularioPerfilMetabaseDashboard.vue')
        },
        {
          path: '/support/sites/financeiro/bonus',
          component: () => import('@/components/views/principal/cadastros/centroDeCusto/ListagemCentroDeCusto')
        },
        {
          path: '/principal/sites/listar',
          name: 'listarSite',
          component: () => import('@/components/views/principal/sites/cadastros/ListagemSite')
        },
        {
          path: '/principal/sites/cadastrar',
          name: 'criarSite',
          component: () => import('@/components/views/principal/sites/cadastros/FormularioSite'),
          props: true
        },
        {
          path: '/principal/sites/alterar/:id',
          name: 'editarSite',
          component: () => import('@/components/views/principal/sites/cadastros/FormularioSite')
        },
        {
          path: '/principal/sites/linksdestaques/listar',
          name: 'listarLinksRapidos',
          component: () => import('@/components/views/principal/sites/linksDestaques/ListagemLinksDestaques')
        },
        {
          path: '/principal/sites/linksdestaques/cadastrar',
          name: 'criarLinksRapidos',
          component: () => import('@/components/views/principal/sites/linksDestaques/FormularioLinksDestaques'),
          props: true
        },
        {
          path: '/principal/sites/linksdestaques/alterar/:id',
          name: 'editarLinksRapidos',
          component: () => import('@/components/views/principal/sites/linksDestaques/FormularioLinksDestaques')
        },
        {
          path: '/principal/sites/cms/paginas/listar',
          name: 'listarCMSPaginas',
          component: () => import('@/components/views/principal/sites/cms/paginas/ListagemPaginas')
        },
        {
          path: '/principal/sites/cms/paginas/cadastrar',
          name: 'criarCMSPaginas',
          component: () => import('@/components/views/principal/sites/cms/paginas/FormularioPaginas'),
          props: true
        },
        {
          path: '/principal/sites/cms/paginas/alterar/:id',
          name: 'editarCMSPaginas',
          component: () => import('@/components/views/principal/sites/cms/paginas/FormularioPaginas')
        },
        {
          path: '/principal/sites/cms/seo/listar',
          name: 'listarCMSSeo',
          component: () => import('@/components/views/principal/sites/cms/seo/ListagemSEO'),
          props: true
        },
        {
          path: '/principal/sites/cms/seo/cadastrar',
          name: 'criarCMSSeo',
          component: () => import('@/components/views/principal/sites/cms/seo/FormularioSEO'),
          props: true
        },
        {
          path: '/principal/sites/cms/seo/alterar/:id',
          name: 'editarCMSSeo',
          component: () => import('@/components/views/principal/sites/cms/seo/FormularioSEO')
        },
        {
          path: '/principal/sites/eventosdestaques/listar',
          name: 'listarEventosDestaques',
          component: () => import('@/components/views/principal/sites/eventosDestaques/ListagemEventosDestaques'),
          props: true
        },
        {
          path: '/principal/sites/cms/noticias/listar',
          name: 'listarCMSNoticias',
          component: () => import('@/components/views/principal/sites/cms/noticias/ListagemNoticias')
        },
        {
          path: '/principal/sites/cms/noticias/cadastrar',
          name: 'criarCMSNoticias',
          component: () => import('@/components/views/principal/sites/cms/noticias/FormulairoNoticias')
        },
        {
          path: '/principal/sites/cms/noticias/alterar/:id',
          name: 'editarCMSNoticias',
          component: () => import('@/components/views/principal/sites/cms/noticias/FormulairoNoticias'),
          props: true
        },
        {
          path: '/principal/sites/eventosdestaques/cadastrar',
          name: 'criarEventosDestaques',
          component: () =>
            import('@/components/views/principal/sites/eventosDestaques/FormularioEventosDestaques'),
          props: true
        },
        {
          path: '/principal/sites/eventosdestaques/alterar/:id',
          name: 'editarEventosDestaques',
          component: () =>
            import('@/components/views/principal/sites/eventosDestaques/FormularioEventosDestaques'),
          props: true
        },
        {
          path: '/principal/sites/metodoPagamento/cartoes/listar',
          name: 'listarCartoes',
          component: () => import('@/components/views/principal/sites/metodoPagamento/cartoes/ListagemCartoes')
        },
        {
          path: '/metodoPagamento/listar',
          component: () => import('@/components/views/principal/sites/fatura/ListagemMeio')
        },
        {
          path: '/metodoPagamento/cadastrar',
          name: 'criarMetodoPagamento',
          component: () => import('@/components/views/principal/sites/fatura/FormularioMeio'),
          props: true
        },
        {
          path: '/metodoPagamento/alterar/:id',
          name: 'editarMetodoPagamento',
          component: () => import('@/components/views/principal/sites/fatura/FormularioMeio')
        },
        {
          path: '/principal/sites/usuariosImpedidos/listar',
          name: 'listagemUsuariosImpedidos',
          component: () => import('@/components/views/principal/sites/usuariosImpedidos/ListagemUsuariosImpedidos')
        },
        {
          path: '/principal/sites/logins/listar',
          name: 'listagemLogins',
          component: () => import('@/components/views/principal/sites/logins/ListagemLogins')
        },
        {
          path: '/principal/sites/logins/cadastrar',
          name: 'criarLogins',
          component: () => import('@/components/views/principal/sites/logins/FormularioLogins'),
          props: true
        },
        {
          path: '/principal/sites/logins/alterar/:id',
          name: 'editarLogins',
          component: () => import('@/components/views/principal/sites/logins/FormularioLogins')
        },
        //Método de pagamento
        {
          path: '/principal/sites/metodoPagamento/listar',
          name: 'listarMP',
          component: () => import('@/components/views/principal/sites/metodoPagamento/ListagemMetodoPagamento')
        },
        {
          path: '/principal/sites/metodoPagamento/cadastrar',
          name: 'criarMP',
          component: () => import('@/components/views/principal/sites/metodoPagamento/FormularioMetodoPagamento'),
          props: true
        },
        {
          path: '/principal/sites/metodoPagamento/alterar/:id',
          name: 'editarMP',
          component: () => import('@/components/views/principal/sites/metodoPagamento/FormularioMetodoPagamento')
        },
        {
          path: '/principal/sites/metodoPagamento/template/cadastrar',
          name: 'criarTMP',
          component: () =>
            import('@/components/views/principal/sites/metodoPagamento/template/FormularioTemplateMP'),
          props: true
        },
        {
          path: '/principal/sites/metodoPagamento/template/alterar/:id',
          name: 'editarTMP',
          component: () =>
            import('@/components/views/principal/sites/metodoPagamento/template/FormularioTemplateMP')
        },
        {
          path: '/principal/sites/metodoPagamento/template/listar',
          name: 'listarTMP',
          component: () => import('@/components/views/principal/sites/metodoPagamento/template/ListagemTemplateMP')
        },
        //BLACKLIST
        {
          path: '/principal/sites/blacklist/listar',
          name: 'listarBlacklist',
          component: () => import('@/components/views/principal/sites/blacklist/ListagemBlacklist')
        },
        {
          path: '/principal/sites/blacklist/alterar/:id',
          name: 'alterarBlacklist',
          component: () => import('@/components/views/principal/sites/blacklist/FormularioBlacklist')
        },
        {
          path: '/principal/sites/blacklist/cadastrar',
          name: 'cadastrarBlacklist',
          component: () => import('@/components/views/principal/sites/blacklist/FormularioBlacklist')
        },
        //PRODUTO
        {
          path: '/principal/cadastros/produto/listar',
          name: 'listarProdutos',
          component: () => import('@/components/views/principal/cadastros/produto/ListagemProduto')
        },
        {
          path: '/principal/cadastros/produto/cadastrar',
          name: 'criarProduto',
          component: () => import('@/components/views/principal/cadastros/produto/FormularioProduto'),
          props: true
        },
        {
          path: '/principal/cadastros/produto/alterar/:id',
          name: 'editarProduto',
          component: () => import('@/components/views/principal/cadastros/produto/FormularioProduto')
        },
        //Games
        {
          path: '/principal/cadastros/games/listar',
          name: 'listarJogo',
          component: () => import('@/components/views/principal/cadastros/game/ListagemGame'),
          props: true
        },
        {
          path: '/principal/cadastros/games/cadastrar',
          name: 'criarJogo',
          component: () => import('@/components/views/principal/cadastros/game/FormularioGame'),
          props: true
        },
        {
          path: '/principal/cadastros/games/alterar/:id',
          name: 'editarJogo',
          component: () => import('@/components/views/principal/cadastros/game/FormularioGame'),
          props: true
        },
        {
          path: '/principal/cadastros/games/categorias/listar',
          name: 'listarCategorias',
          component: () =>
            import('@/components/views/principal/cadastros/game/categorias/ListagemCategoriasGames.vue'),
          props: true
        },
        {
          path: '/principal/cadastros/games/categorias/cadastrar',
          name: 'cadastrarCategorias',
          component: () =>
            import('@/components/views/principal/cadastros/game/categorias/FormularioCategoriasGames'),
          props: true
        },
        {
          path: '/principal/cadastros/games/categorias/alterar/:id',
          name: 'editarCategorias',
          component: () =>
            import('@/components/views/principal/cadastros/game/categorias/FormularioCategoriasGames'),
          props: true
        },
        //Versão de Aplicativo
        {
          path: '/principal/sites/versaoApp/listar',
          name: 'listarVersoesApp',
          component: () => import('@/components/views/principal/sites/versaoApp/ListagemVersaoApp.vue'),
          props: true
        },
        {
          path: '/principal/sites/versaoApp/cadastrar',
          name: 'cadastrarVersaoApp',
          component: () => import('@/components/views/principal/sites/versaoApp/FormularioVersaoApp'),
          props: true
        },
        {
          path: '/principal/sites/versaoApp/alterar/:id',
          name: 'editarVersaoApp',
          component: () => import('@/components/views/principal/sites/versaoApp/FormularioVersaoApp'),
          props: true
        },
        //Perfis
        {
          path: '/principal/cadastros/perfil/imposto/listar',
          name: 'listarPerfilImposto',
          component: () => import('@/components/views/principal/cadastros/perfil/imposto/ListagemPerfilImposto')
        },
        {
          path: '/principal/cadastros/perfil/imposto/cadastrar',
          name: 'criarPerfilImposto',
          component: () => import('@/components/views/principal/cadastros/perfil/imposto/FormularioPerfilImposto'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/imposto/alterar/:id',
          name: 'editarPerfilImposto',
          component: () => import('@/components/views/principal/cadastros/perfil/imposto/FormularioPerfilImposto'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/usuario/listar',
          name: 'listarPerfilUsuario',
          component: () => import('@/components/views/principal/cadastros/perfil/usuario/ListagemPerfilUsuario')
        },
        {
          path: '/principal/cadastros/perfil/usuario/cadastrar',
          name: 'criarPerfilUsuario',
          component: () => import('@/components/views/principal/cadastros/perfil/usuario/FormularioPerfilUsuario'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/usuario/alterar/:id',
          name: 'editarPerfilUsuario',
          component: () => import('@/components/views/principal/cadastros/perfil/usuario/FormularioPerfilUsuario'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/cotacaoFavorito/listar',
          name: 'listarPerfilCotacaoFavorito',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/cotacaoFavorito/ListagemPerfilCotacaoFavorito')
        },
        ,
        {
          path: '/principal/cadastros/perfil/cotacaoFavorito/cadastrar',
          name: 'criarPerfilCotacaoFavorito',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/cotacaoFavorito/FormularioPerfil'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/cotacaoFavorito/alterar/:id',
          name: 'editarPerfilCotacaoFavorito',
          component: () => import('@/components/views/principal/cadastros/perfil/cotacaoFavorito/FormularioPerfil')
        },
        {
          path: '/principal/cadastros/perfil/cotacao/listar',
          name: 'listarPerfilCotacao',
          component: () => import('@/components/views/principal/cadastros/perfil/cotacao/ListagemPerfilCotacao')
        },
        ,
        {
          path: '/principal/cadastros/perfil/cotacao/cadastrar',
          name: 'criarPerfilCotacao',
          component: () => import('@/components/views/principal/cadastros/perfil/cotacao/FormularioPerfil'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/cotacao/alterar/:id',
          name: 'editarPerfilCotacao',
          component: () => import('@/components/views/principal/cadastros/perfil/cotacao/FormularioPerfil'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/limiteDefesa/listar',
          name: 'listarPerfilLimiteDefesa',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/limiteDefesa/ListagemPerfilLimiteDefesa')
        },
        ,
        {
          path: '/principal/cadastros/perfil/limiteDefesa/cadastrar',
          name: 'criarPerfilLimiteDefesa',
          component: () => import('@/components/views/principal/cadastros/perfil/limiteDefesa/FormularioPerfil'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/limiteDefesa/alterar/:id',
          name: 'editarPerfilLimiteDefesa',
          component: () => import('@/components/views/principal/cadastros/perfil/limiteDefesa/FormularioPerfil')
        },
        {
          path: '/principal/cadastros/perfil/defesaOddsAutomaticas/listar',
          name: 'listarAjusteAutomatico',
          component: () =>
            import(
              '@/components/views/principal/cadastros/perfil/defesaOddsAutomaticas/ListagemDefesaOddsAutomaticas'
            )
        },
        {
          path: '/principal/cadastros/perfil/defesaOddsAutomaticas/cadastrar',
          name: 'criarAjusteAutomatico',
          component: () =>
            import(
              '@/components/views/principal/cadastros/perfil/defesaOddsAutomaticas/FormularioDefesaOddsAutomaticas'
            ),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/defesaOddsAutomaticas/alterar/:id',
          name: 'editarAjusteAutomatico',
          component: () =>
            import(
              '@/components/views/principal/cadastros/perfil/defesaOddsAutomaticas/FormularioDefesaOddsAutomaticas'
            )
        },
        {
          path: '/principal/cadastros/perfil/subevento/listar',
          name: 'listarPerfilSubevento',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/subevento/ListagemPerfilSubevento')
        },
        {
          path: '/principal/cadastros/perfil/subevento/cadastrar',
          name: 'criarPerfilSubevento',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/subevento/FormularioPerfilSubevento'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/subevento/alterar/:id',
          name: 'editarPerfilSubevento',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/subevento/FormularioPerfilSubevento'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/subevento/bloquearModalidades/:id',
          name: 'bloquearModalidades',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/subevento/FormularioBloquearModalidades'),
          props: true
        },
        {
          path: '/principal/cadastros/perfil/subevento/rentabilidade/:id',
          name: 'rentabilidade',
          component: () =>
            import('@/components/views/principal/cadastros/perfil/subevento/FormularioRentabilidade'),
          props: true
        },
        // Gestor Lotérico (rotas)
        {
          path: '/principal/cadastros/gestorLoterico/apostador/listar',
          name: 'listarApostadorGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/apostador/ListagemApostador')
        },
        {
          path: '/principal/cadastros/gestorLoterico/apostador/cadastrar',
          name: 'cadastrarApostadorGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/apostador/FormularioApostador'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/apostador/alterar/:id',
          name: 'editarApostadorGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/apostador/FormularioApostador'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/pos/listar',
          name: 'listarPos',
          component: () => import('@/components/views/principal/cadastros/gestorLoterico/pos/ListagemPos')
        },
        {
          path: '/principal/cadastros/gestorLoterico/pos/cadastrar',
          name: 'cadastrarPos',
          component: () => import('@/components/views/principal/cadastros/gestorLoterico/pos/FormularioPos'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/pos/alterar/:id',
          name: 'editarPos',
          component: () => import('@/components/views/principal/cadastros/gestorLoterico/pos/FormularioPos'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/produto/listar',
          name: 'listarProdutoGl',
          component: () => import('@/components/views/principal/cadastros/gestorLoterico/produto/ListagemProduto')
        },
        {
          path: '/principal/cadastros/gestorLoterico/produto/cadastrar',
          name: 'cadastrarProdutoGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/produto/FormularioProduto'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/produto/alterar/:id',
          name: 'editarProdutoGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/produto/FormularioProduto'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/terminal/listar',
          name: 'listarTerminalGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/terminal/ListagemTerminal')
        },
        {
          path: '/principal/cadastros/gestorLoterico/terminal/cadastrar',
          name: 'cadastrarTerminalGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/terminal/FormularioTerminal'),
          props: true
        },
        {
          path: '/principal/cadastros/gestorLoterico/terminal/alterar/:id',
          name: 'editarTerminalGl',
          component: () =>
            import('@/components/views/principal/cadastros/gestorLoterico/terminal/FormularioTerminal'),
          props: true
        },
        //cms
        {
          path: '/principal/sites/cms/banners/cadastrar',
          name: 'cadastrarBannerCms',
          component: () => import('@/components/views/principal/sites/cms/banners/FormularioBanners')
        },
        {
          path: '/principal/sites/cms/banners/alterar/:id',
          name: 'editarBannerCms',
          component: () => import('@/components/views/principal/sites/cms/banners/FormularioBanners'),
          props: true
        },
        {
          path: '/principal/sites/cms/banners/listar',
          name: 'listarBannersCms',
          component: () => import('@/components/views/principal/sites/cms/banners/ListagemBanners')
        },
        {
          path: '/principal/sites/promo/listar',
          name: 'listagemPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/ListagemPromo')
        },
        {
          path: '/principal/sites/promo/cadastrar',
          name: 'criarPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/FormularioPromo')
        },
        {
          path: '/principal/sites/promo/alterar/:id',
          name: 'editarPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/FormularioPromo')
        },
        {
          path: '/principal/sites/promo/template/listar',
          name: 'listagemTemplatePromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/ListagemTemplatePromo')
        },
        {
          path: '/principal/sites/promo/template/cadastrar',
          name: 'criarTemplatePromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/FormularioTemplatePromo')
        },
        {
          path: '/principal/sites/promo/template/alterar/:id',
          name: 'editarTemplatePromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/FormularioTemplatePromo')
        },
        {
          path: '/principal/sites/promo/remessa/listar',
          name: 'listagemRemessaPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/remessa/ListagemRemessa')
        },
        {
          path: '/principal/sites/promo/remessa/cadastrar',
          name: 'criarRemessaPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/remessa/FormularioRemessa')
        },
        {
          path: '/principal/sites/promo/remessa/alterar/:id',
          name: 'editarRemessaPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/remessa/FormularioRemessa')
        },
        // Xtremepush
        {
          path: '/principal/sites/promo/xtremepush/listar',
          name: 'listagemXtremepushPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/xtremepush/ListagemXtremepush')
        },
        {
          path: '/principal/sites/promo/xtremepush/cadastrar',
          name: 'criarXtremepushPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/xtremepush/FormularioXtremepush')
        },
        {
          path: '/principal/sites/promo/xtremepush/alterar/:id',
          name: 'editarXtremepushPromo',
          component: () => import('@/components/views/principal/sites/moduloPromo/xtremepush/FormularioXtremepush')
        },
        // Resultados
        {
          path: '/principal/resultados/listagem',
          name: 'ResultadosListagem',
          component: () => import('@/components/views/principal/resultado/listagem/Resultados.vue')
        },
        {
          path: '/principal/resultados/pendentes',
          name: 'ResultadosPendentes',
          component: () => import('@/components/views/principal/resultado/pendentes/ResultadosPendentes.vue')
        },

        // <<< relatórios >>>
        {
          path: '/relatorios/financeiro/Apurado',
          name: 'relatorioFinanceiroApurado',
          component: () => import('@/components/views/relatorios/financeiro/Apurado')
        },
        {
          path: '/relatorios/financeiro/liquido',
          name: 'relatorioFinanceiroLiquido',
          component: () => import('@/components/views/relatorios/financeiro/LiquidoPorTipoUsuario.vue')
        },
        {
          path: '/relatorios/financeiro/vendasProdutosExternos',
          name: 'vendasProdutosExternos',
          component: () => import('@/components/views/relatorios/financeiro/VendasProdutosExternos.vue')
        },
        //<<< relatorioApuradoBolao está pronto >>>
        {
          path: '/relatorios/bolao/apuradoBolao',
          name: 'relatorioApuradoBolao',
          component: () => import('@/components/views/relatorios/bolao/apuradoPorBolao/ReportApuradoBolao')
        },

        {
          path: '/relatorios/bolao/vendaBolao',
          name: 'relatorioVendaBolao',
          component: () => import('@/components/views/relatorios/bolao/vendaBolao/ReportVendaBolao')
        },
        // Principal > Financeiro

        {
          path: '/principal/financeiro/extratoComSaldo',
          name: 'extratoComSaldo',
          component: () => import('@/components/views/principal/financeiro/ExtratoComSaldoReport')
        },
        {
          path: '/corteFinanceiro',
          name: 'corteFinanceiro',
          component: () =>
            import('@/components/views/principal/financeiro/CorteFinanceiro/CorteFinanceiroReport.vue')
        },
        {
          path: '/agendamento/despesa/listar',
          name: 'despesa',
          component: () =>
            import('@/components/views/principal/financeiro/Agendamentos/Despesa/ListagemAgendamentoDespesa.vue')
        },
        {
          path: '/agendamento/despesa/cadastrar',
          name: 'agendarDespesa',
          component: () =>
            import('@/components/views/principal/financeiro/Agendamentos/Despesa/FormularioAgendamentoDespesa.vue')
        },
        {
          path: '/acerto/listar',
          name: 'LancamentosReport',
          component: () => import('@/components/views/principal/financeiro/lancamentos/LancamentosReport')
        },
        {
          path: '/acerto/cadastrar',
          name: 'criarLancamento',
          component: () => import('@/components/views/principal/financeiro/lancamentos/NovoLancamentoReport')
        },
        {
          path: '/estabelecimento/saldo/listar',
          name: 'MonitorFinanceiroReport',
          component: () => import('@/components/views/principal/financeiro/monitor/MonitorFinanceiroReport')
        },
        {
          path: '/relatorios/financeiro/ApuradoDespesas',
          name: 'relatorioFinanceiroApuradoDespesas',
          component: () => import('@/components/views/relatorios/financeiro/ApuradoDespesas')
        },
        {
          path: '/relatorios/financeiro/ApuradoOrigem',
          name: 'ApuradoOrigem',
          component: () => import('@/components/views/relatorios/financeiro/apuradoOrigem/ApuradoOrigemReport')
        },
        {
          path: '/relatorios/financeiro/ApuradoMetodoPagamento',
          name: 'ApuradoMetodoPagamento',
          component: () => import('@/components/views/relatorios/financeiro/ApuradoV3.vue')
        },
        {
          path: '/relatorios/financeiro/ApuradoUsuario',
          name: 'ApuradoUsuario',
          component: () => import('@/components/views/relatorios/financeiro/apuradoUsuario/ApuradoUsuario.vue')
        },
        {
          path: '/relatorios/financeiro/ApuradoOrigemDespesas',
          name: 'ApuradoOrigemDespesas',
          component: () =>
            import('@/components/views/relatorios/financeiro/apuradoOrigemDespesas/ApuradoOrigemDespesasReport')
        },
        {
          path: '/relatorios/financeiro/posicaoDiaria',
          name: 'relatorioFinanceiroPosicaoDiaria',
          component: () => import('@/components/views/relatorios/financeiro/posicaoDiaria/posicaoDiaria')
        },
        {
          path: '/relatorios/financeiro/acertoFinanceiro',
          name: 'acertoFinanceiro',
          component: () => import('@/components/views/relatorios/financeiro/acertoFinanceiro/acertoFinanceiro')
        },
        {
          path: '/relatorios/financeiro/evolucaoPontos',
          name: 'evolucaoPontos',
          component: () => import('@/components/views/relatorios/financeiro/evolucao/ReportPontos')
        },
        {
          path: '/relatorios/financeiro/coletaReport',
          name: 'coletaReport',
          component: () => import('@/components/views/relatorios/financeiro/coleta/ReportColeta')
        },
        {
          path: '/relatorios/financeiro/comissaoRetidaReport',
          name: 'comissaoRetidaReport',
          component: () => import('@/components/views/relatorios/financeiro/comissaoRetida/comissaoRetidaReport')
        },
        {
          path: '/despesaReport',
          name: 'despesaReport',
          component: () => import('@/components/views/relatorios/financeiro/despesa/despesaReport')
        },
        {
          path: '/relatorios/financeiro/evolucaoVendas',
          name: 'evolucaoVendas',
          component: () => import('@/components/views/relatorios/financeiro/evolucao/ReportVendas')
        },
        {
          path: '/relatorios/financeiro/guiaDeMovimentoLoja',
          name: 'listagemGuiaDeMovimentoLoja',
          component: () =>
            import('@/components/views/relatorios/financeiro/guiaDeMovimentoLoja/ListagemGuiaMovimentoLoja')
        },
        {
          path: '/relatorios/financeiro/monitorOperacionalTransacoes',
          name: 'listagemMonitorOperacionalTransacoes',
          component: () =>
            import(
              '@/components/views/relatorios/financeiro/monitorOperacionalTransacoes/MonitorOperacionalTransacoes.vue'
            )
        },
        {
          path: '/relatorios/financeiro/guiaPorHora',
          name: 'guiaPorHora',
          component: () => import('@/components/views/relatorios/financeiro/guiaPorHora/guiaPorHora')
        },

        {
          path: '/relatorios/financeiro/pontosInoperantesReport',
          name: 'pontosInoperantesReport',
          component: () =>
            import('@/components/views/relatorios/financeiro/pontosInoperantes/PontosInoperantesReport.vue')
        },
        {
          path: '/relatorios/financeiro/seriaisInoperantes',
          name: 'seriaisInoperantes',
          component: () =>
            import('@/components/views/relatorios/financeiro/seriaisInoperantes/SeriaisInoperantesReport.vue')
        },
        {
          path: '/relatorios/financeiro/VendasPorEstado',
          name: 'vendasPorEstado',
          component: () =>
            import('@/components/views/relatorios/financeiro/vendasPorEstado/VendasPorEstadoReport.vue')
        },
        {
          path: '/relatorios/financeiro/pontosOperandoReport',
          name: 'pontosOperandoReport',
          component: () =>
            import('@/components/views/relatorios/financeiro/pontosOperando/PontosOperandoReport.vue')
        },

        {
          path: '/relatorios/sites/transacoes',
          name: 'relatorioSitesTransacoes',
          component: () => import('@/components/views/relatorios/sites/Transacoes')
        },
        {
          path: '/relatorios/sites/transacoesLocalidadeAgrupado',
          name: 'relatorioSitesTransacoesLocalidadeAgrupado',
          component: () => import('@/components/views/relatorios/sites/TransacoesLocalidade')
        },
        {
          path: '/relatorios/sites/transacoesPorLocalidade',
          name: 'relatorioSitesTransacoesLocalidade',
          component: () =>
            import(
              '@/components/views/relatorios/sites/transacoesPorLocalidadeDetalhada/TransacoesPorLocalidadeDetalhadaReport.vue'
            )
        },
        {
          path: '/relatorios/sites/transacoesMetodo',
          name: 'relatorioSitestransacoesMetodo',
          component: () => import('@/components/views/relatorios/sites/TransacoesMetodo')
        },
        {
          path: '/relatorios/sites/posicaoSaldo',
          name: 'relatorioSitesPosicaoSaldo',
          component: () => import('@/components/views/relatorios/sites/PosicaoSaldo')
        },
        {
          path: '/relatorios/sites/operacional/apostas',
          name: 'relatorioSitesTurnover',
          component: () => import('@/components/views/relatorios/sites/turnover/Turnover')
        },
        {
          path: '/relatorios/sites/operacional/apostas/moeda',
          name: 'relatorioSitesTurnoverMoeda',
          component: () => import('@/components/views/relatorios/sites/turnoverMoeda/Turnover')
        },
        {
          path: '/reports/sites/operacional/gamesTurnover',
          name: 'reportGamesTurnover',
          component: () => import('@/components/views/relatorios/sites/turnoverGames/TurnoverGames')
        },
        {
          path: '/relatorios/sites/operacional/clientesAtivos',
          name: 'relatorioSitesActivePlayers',
          component: () => import('@/components/views/relatorios/sites/ActivePlayers')
        },
        {
          path: '/relatorios/sites/operacional/lancamentosManuais',
          name: 'relatorioSitesLancamentosManuais',
          component: () => import('@/components/views/relatorios/sites/lancamentosManuais/LancamentosManuais.vue')
        },
        {
          path: '/relatorios/sites/operacional/clientesAtivosComDeposito',
          name: 'relatorioSitesNewFundedPlayers',
          component: () => import('@/components/views/relatorios/sites/NewFundedPlayers')
        },
        {
          path: '/relatorios/sites/operacional/usuariosSemDepositos',
          name: 'relatorioUsuarioSemDeposito',
          component: () => import('@/components/views/relatorios/sites/usuariosSemDepositos/UsuariosSemDepositos')
        },
        {
          path: '/relatorios/sites/operacional/usuariosEmPausa',
          name: 'relatorioUsuarioEmPausa',
          component: () => import('@/components/views/relatorios/sites/usuariosEmPausa/UsuariosEmPausa')
        },
        {
          path: '/relatorios/sites/operacional/usuariosAutoLimitados',
          name: 'relatorioUsuariosAutoLimitados',
          component: () => import('@/components/views/relatorios/sites/usuariosEmPausa/UsuariosAutoLimitados')
        },
        {
          path: '/relatorios/sites/operacional/performancePromo',
          name: 'relatorioPerformancePromo',
          component: () => import('@/components/views/relatorios/sites/performance/PerformanceReport')
        },
        {
          path: '/relatorios/sites/operacional/freeSpins',
          name: 'relatorioFreeSpins',
          component: () => import('@/components/views/relatorios/sites/freeSpins/FreeSpins.vue')
        },
        {
          path: '/relatorios/sites/operacional/registros',
          name: 'relatorioSitesSignUps',
          component: () => import('@/components/views/relatorios/sites/SignUps')
        },
        {
          path: '/relatorios/financeiro/consumoBobinas',
          name: 'relatorioConsumoBobinas',
          component: () => import('@/components/views/relatorios/financeiro/ConsumoBobinas')
        },
        {
          path: '/relatorios/sites/financeiro/bonus',
          name: 'relatorioSitesBonus',
          component: () => import('@/components/views/relatorios/sites/Bonus')
        },
        {
          path: '/relatorios/sites/financeiro/resgates',
          name: 'relatorioSitesResgates',
          component: () => import('@/components/views/relatorios/sites/Resgates')
        },
        {
          path: '/relatorios/sites/financeiro/depositos',
          name: 'relatorioSitesDepositos',
          component: () => import('@/components/views/relatorios/sites/Depositos')
        },
        {
          path: '/relatorios/sites/financeiro/movimento',
          name: 'relatorioSitesMovimento',
          component: () => import('@/components/views/relatorios/sites/Movimento')
        },
        {
          path: '/relatorios/financeiro/ticketMedio',
          name: 'ticketMedio',
          component: () => import('@/components/views/relatorios/financeiro/ticketMedio/ticketMedio')
        },
        {
          path: '/relatorios/financeiro/transacoesAltoValor',
          name: 'transacoesAltoValor',
          component: () => import('@/components/views/relatorios/financeiro/auditoria/TransacoesValorAlto')
        },
        {
          path: '/relatorios/financeiro/trilhaAuditoria',
          name: 'trilhaAuditoria',
          component: () => import('@/components/views/relatorios/financeiro/auditoria/TrilhaAuditoria')
        },
        {
          path: '/relatorios/financeiro/auditoriaProdutosEstaduais',
          name: 'auditoriaProdutosEstaduais',
          component: () => import('@/components/views/relatorios/financeiro/auditoria/AuditoriaProdutosEstaduais')
        },
        {
          path: '/relatorios/financeiro/cobrancaReport',
          name: 'cobranca',
          component: () => import('@/components/views/relatorios/financeiro/cobranca/ReportCobranca')
        },
        {
          path: '/relatorios/financeiro/centroDeCusto',
          name: 'centroDeCusto',
          component: () => import('@/components/views/relatorios/financeiro/centroDeCusto/centroDeCusto')
        },
        {
          path: '/relatorios/financeiro/bilhetesPorPartidaReport',
          name: 'relatorioBilhetesPorPartida',
          component: () => import('@/components/views/relatorios/financeiro/BilhetesPorPartida')
        },
        {
          path: '/relatorios/financeiro/listagemBilhetes',
          name: 'listagemBilhetes',
          component: () => import('@/components/views/relatorios/financeiro/listagemBilhetes/listagemBilhetes')
        },
        {
          path: '/relatorios/financeiro/tipoAposta',
          name: 'tipoAposta',
          component: () => import('@/components/views/relatorios/financeiro/tipoAposta/tipoAposta')
        },
        {
          path: '/relatorios/financeiro/premioPagoMetodoPagamento',
          name: 'premioPagoMetodoPagamento',
          component: () =>
            import('@/components/views/relatorios/financeiro/premioPagoMetodoPagamento/premioPagoMetodoPagamento')
        },
        {
          path: '/relatorios/financeiro/extrato',
          name: 'extrato',
          component: () => import('@/components/views/relatorios/financeiro/extrato/extrato')
        },
        {
          path: '/relatorios/financeiro/comissaoPorFaixa',
          name: 'comissaoPorFaixa',
          component: () =>
            import('@/components/views/relatorios/financeiro/comissaoPorFaixa/ReportComissaoPorFaixa')
        },
        // Relatórios/rede
        {
          path: '/relatorios/rede/cancelamentos/CancelamentosReport',
          name: 'Cancelamentos',
          component: () => import('@/components/views/relatorios/rede/cancelamentos/CancelamentosReport')
        },
        {
          path: '/relatorios/rede/versoesUsuario/VersoesUsuarioReport',
          name: 'VersoesUsuario',
          component: () => import('@/components/views/relatorios/rede/versoesUsuario/VersoesUsuarioReport')
        },
        // <<< gerência >>>
        //
        {
          path: '/principal/sigap/operadorMensal/listar',
          name: 'listagemOperadorMensal',
          component: () => import('@/components/views/principal/sigap/operadorMensal/ListagemOperadorMensal')
        },
        {
          path: '/principal/sigap/operadorMensal/cadastrar',
          name: 'formularioOperadorMensal',
          component: () => import('@/components/views/principal/sigap/operadorMensal/FormularioOperadorMensal')
        },
        {
          path: '/principal/sigap/retificacao/listar',
          name: 'listagemRetificacaoSigap',
          component: () => import('@/components/views/principal/sigap/retificacao/ListagemRetificacao')
        },
        {
          path: '/principal/sigap/retificacao/cadastrar',
          name: 'formularioRetificacaoSigap',
          component: () => import('@/components/views/principal/sigap/retificacao/FormularioRetificacao')
        },
        {
          path: '/principal/sigap/correcao/listar',
          name: 'listagemCorrecaoSigap',
          component: () => import('@/components/views/principal/sigap/correcao/ListagemCorrecao')
        },
        {
          path: '/principal/sigap/correcao/cadastrar',
          name: 'formularioCorrecaoSigap',
          component: () => import('@/components/views/principal/sigap/correcao/FormularioCorrecao')
        },
        {
          path: '/principal/sigap/envios/listar',
          name: 'ListagemEnviosSigap',
          component: () => import('@/components/views/principal/sigap/envios/ListagemEnviosSigap')
        },
        {
          path: '/principal/sigap/movimentos/listar',
          name: 'ListagemMovimentoSigap',
          component: () => import('@/components/views/principal/sigap/movimentos/ListagemMovimentoSigap')
        },
        {
          path: '/principal/sigap/devolucao/listar',
          name: 'ListagemDevolucaoSigap',
          component: () => import('@/components/views/principal/sigap/devolucao/ListagemDevolucaoSigap')
        },
        {
          path: '/principal/gerencia/bolao/listar',
          name: 'listarBolao',
          component: () => import('@/components/views/principal/gerencia/bolao/ListagemBolao')
        },
        {
          path: '/principal/gerencia/bolao/cadastrar',
          name: 'criarBolao',
          component: () => import('@/components/views/principal/gerencia/bolao/FormularioBolao'),
          props: true
        },
        {
          path: '/principal/gerencia/bolao/alterar/:id',
          name: 'editarBolao',
          component: () => import('@/components/views/principal/gerencia/bolao/FormularioBolao'),
          props: true
        },
        {
          path: '/principal/gerencia/prioridadeSubevento/listar',
          name: 'listarPrioridadeSubevento',
          component: () =>
            import(
              '@/components/views/principal/gerencia/configuracao/prioridadeSubevento/ListagemPrioridadeSubevento'
            )
        },
        {
          path: '/principal/gerencia/prioridadeSubevento/cadastrar',
          name: 'criarPrioridadeSubevento',
          component: () =>
            import(
              '@/components/views/principal/gerencia/configuracao/prioridadeSubevento/FormularioPrioridadeSubevento'
            ),
          props: true
        },
        {
          path: '/principal/gerencia/prioridadeSubevento/alterar/:id',
          name: 'editarPrioridadeSubevento',
          component: () =>
            import(
              '@/components/views/principal/gerencia/configuracao/prioridadeSubevento/FormularioPrioridadeSubevento'
            ),
          props: true
        },
        {
          path: '/principal/gerencia/superOdds/listarConfiguracoes',
          name: 'listagemSuperOdds',
          component: () => import('@/components/views/principal/gerencia/configuracao/superOdds/ListagemSuperOdds')
        },
        {
          path: '/principal/gerencia/superOdds/cadastrar',
          name: 'formularioSuperOdds',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/superOdds/FormularioSuperOdds'),
          props: true
        },
        {
          path: '/principal/gerencia/superOdds/alterar/:id',
          name: 'formularioSuperOddsAlterar',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/superOdds/FormularioSuperOdds'),
          props: true
        },
        {
          path: '/principal/gerencia/riscoAcumuladoSuperOdds/listar',
          name: 'listagemRiscoAcumuladoSuperOdds',
          component: () =>
            import('@/components/views/principal/gerencia/riscoAcumuladoSuperOdds/RiscoAcumuladoSuperOdds')
        },
        {
          path: '/principal/gerencia/configuracoes/bloqueios',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/bloqueios/ListagemGerenciaBloqueios')
        },
        {
          path: '/principal/gerencia/configuracoes/competicoes',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/competicoes/ListagemGerenciaCompeticoes')
        },
        {
          name: 'formularioCompeticao',
          path: '/principal/gerencia/configuracoes/competicoes/cadastrar',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/competicoes/FormularioGerenciaCompeticoes')
        },
        {
          name: 'listagemGerenciaEvento',
          path: '/principal/gerencia/configuracoes/evento',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/evento/ListagemGerenciaEvento')
        },
        {
          path: '/principal/gerencia/configuracoes/evento/alterar',
          name: 'formularioGerenciaEventoAlterar',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/evento/FormularioGerenciaEvento')
        },
        {
          path: '/principal/gerencia/configuracoes/evento/cadastrar',
          name: 'formularioGerenciaEventoCadastrar',
          component: () =>
            import('@/components/views/principal/gerencia/configuracao/evento/FormularioGerenciaEvento')
        },
        {
          path: '/principal/gerencia/esporte/listar',
          component: () => import('@/components/views/principal/gerencia/esporte/ListagemEsporte')
        },
        {
          path: '/principal/gerencia/esporte/alterar/:id',
          name: 'editarEsporte',
          component: () => import('@/components/views/principal/gerencia/esporte/FormularioEsporte')
        },
        {
          path: '/principal/gerencia/esporte/cadastrar',
          name: 'criarEsporte',
          component: () => import('@/components/views/principal/gerencia/esporte/FormularioEsporte'),
          props: true
        },
        {
          path: '/principal/gerencia/cotacao/listar',
          name: 'listarCotacoes',
          component: () => import('@/components/views/principal/gerencia/cotacao/ListagemCotacao')
        },
        {
          path: '/principal/gerencia/preferenciaApi/listar',
          name: 'listarPreferenciasAPi',
          component: () =>
            import('@/components/views/principal/gerencia/preferenciasApi/ListagemPreferenciasAPI.vue')
        },
        {
          path: '/principal/gerencia/preferenciaApi/cadastrar',
          name: 'cadastrarPreferenciasAPi',
          component: () =>
            import('@/components/views/principal/gerencia/preferenciasApi/FormularioPreferenciasAPI.vue')
        },
        {
          path: '/principal/gerencia/preferenciaApi/alterar/:id',
          name: 'alterarPreferenciasAPi',
          component: () =>
            import('@/components/views/principal/gerencia/preferenciasApi/FormularioPreferenciasAPI.vue'),
          props: true
        },
        {
          path: '/principal/gerencia/risco/listar',
          name: 'listarGerenciaRisco',
          component: () => import('@/components/views/principal/gerencia/risco/ListagemRisco')
        },
        {
          path: '/principal/gerencia/risco/acumulado/listar',
          name: 'listarGerenciaRiscoAcumulado',
          component: () => import('@/components/views/principal/gerencia/riscoAcumulado/RiscoAcumulado')
        },
        {
          path: '/principal/gerencia/monitor/listar',
          name: 'listarDefesasMonitor',
          component: () => import('@/components/views/principal/gerencia/monitor/ListagemMonitor')
        },
        {
          path: '/principal/gerencia/controleIp/listar',
          name: 'listarControle',
          component: () => import('@/components/views/principal/gerencia/controleIp/ListagemControleIp')
        },
        {
          path: '/gerencia/riscoPorCombinacao/listar',
          name: 'ListagemRisco',
          component: () => import('@/components/views/principal/gerencia/riscoPorCombinacao/ListagemRisco')
        },
        {
          path: '/gerencia/configuracaoDefesa/listar',
          name: 'ListagemConfigDefesa',
          component: () =>
            import('@/components/views/principal/gerencia/configuracaoDefesa/ListagemConfiguracaoDefesa')
        },
        {
          path: '/relatorios/sites/saques',
          name: 'relatorioSiteSaques',
          component: () => import('@/components/views/relatorios/sites/saques/Saques')
        },
        {
          path: '/relatorios/sites/pin',
          name: 'relatorioSitePin',
          component: () => import('@/components/views/relatorios/sites/saques/Pin')
        },
        {
          path: '/relatorios/sites/sms',
          name: 'relatorioSiteSms',
          component: () => import('@/components/views/relatorios/sites/sms/SmsReport')
        },
        {
          path: '/relatorios/sites/operacional/prizeDrops',
          name: 'relatorioPrizeDrops',
          component: () => import('@/components/views/relatorios/sites/prizeDrops/PrizeDrops.vue')
        },
        {
          path: '/relatorios/sites/cobrancaDeProdutos',
          name: 'cobrancaDeProdutos',
          component: () =>
            import('@/components/views/relatorios/sites/CobrancaPorProduto/CobrancaPorProdutoReport.vue')
        },
        {
          path: '/relatorios/sites/saldoPin',
          name: 'saldoPin',
          component: () => import('@/components/views/relatorios/sites/SaldoPin/SaldoPinReport.vue')
        },
        {
          path: '/relatorios/sites/eventosFuturos',
          name: 'eventosFuturosReport',
          component: () => import('@/components/views/relatorios/sites/EventosFuturos/EventosFuturosReport.vue')
        },
        {
          path: '/relatorios/sites/financeiro/darf',
          name: 'relatorioDarf',
          component: () => import('@/components/views/relatorios/sites/darf/DarfReport.vue')
        },
        // <<< monitor >>>
        {
          path: '/monitor/trading/grupoOrigem/listar',
          name: 'listarGrupoOrigem',
          component: () => import('@/components/views/monitor/trading/grupoOrigem/ListagemGrupoOrigem')
        },
        {
          path: '/monitor/trading/evento/listar',
          name: 'listarEvento',
          component: () => import('@/components/views/monitor/trading/evento/ListagemEvento')
        },
        {
          path: '/monitor/trading/grupo/listar',
          name: 'listarGrupo',
          component: () => import('@/components/views/monitor/trading/grupo/ListagemGrupo')
        },
        {
          path: '/monitor/trading/risco/listar',
          name: 'Risco',
          component: () => import('@/components/views/monitor/trading/risco/ListagemRisco.vue')
        },
        {
          path: '/principal/monitor/trading/tipoSubevento/listar',
          name: 'listarTipoSubevento',
          component: () => import('@/components/views/monitor/trading/tipoSubevento/ListagemTipoSubevento')
        },
        {
          path: '/principal/monitor/trading/tipoSubevento/alterar/:id',
          name: 'editarTipoSubevento',
          component: () => import('@/components/views/monitor/trading/tipoSubevento/FormularioTipoSubevento'),
          props: true
        },
        {
          path: '/monitor/trading/multiplosFornecedores/listar',
          name: 'listarMultiplosFornecedores',
          component: () =>
            import('@/components/views/monitor/trading/multiplosFornecedores/ListagemMultiplosForn.vue')
        },
        {
          path: '/monitor/trading/multiplosFornecedores/cadastrar',
          name: 'cadastrarMultiplosFornecedores',
          component: () =>
            import('@/components/views/monitor/trading/multiplosFornecedores/FormularioMultiplosForn.vue')
        },
        {
          path: '/monitor/trading/multiplosFornecedores/editar/:id',
          name: 'editarMultiplosFornecedores',
          component: () =>
            import('@/components/views/monitor/trading/multiplosFornecedores/FormularioMultiplosForn.vue')
        },
        {
          path: '/monitor/trading/templateOdd/listar',
          name: 'listarTemplateOdd',
          component: () => import('@/components/views/monitor/trading/templateOdd/ListagemTemplateOdd.vue')
        },
        {
          path: '/monitor/trading/templateOdd/cadastrar',
          name: 'cadastrarTemplateOdd',
          component: () => import('@/components/views/monitor/trading/templateOdd/FormularioTemplateOdd.vue')
        },
        {
          path: '/monitor/trading/templateOdd/editar/:id',
          name: 'editarTemplateOdd',
          component: () => import('@/components/views/monitor/trading/templateOdd/FormularioTemplateOdd.vue')
        },
        {
          path: '/resultados/automatico/pendentes',
          component: () => import('@/components/views/monitor/resultado/pendente/ListagemResultadoPendente')
        },
        {
          path: '/monitor/trading/fornecedor/listar',
          name: 'listarFornecedor',
          component: () => import('@/components/views/monitor/trading/fornecedor/ListagemFornecedor')
        },
        {
          path: '/monitor/trading/eventosMercadoAberto/listar',
          name: 'listarEventosMercadoAberto',
          component: () =>
            import('@/components/views/monitor/trading/eventosMercadoAberto/ListagemEventosMercadoAberto')
        },
        {
          path: '/monitor/trading/mercadoAberto/listar',
          name: 'listarMercadoAberto',
          component: () => import('@/components/views/monitor/trading/mercadoAberto/ListagemMercadoAberto')
        },
        {
          path: '/resultados/automatico/agendamentos',
          component: () => import('@/components/views/monitor/resultado/agendamento/ListagemResultadoAgendamento')
        },
        {
          path: '/monitor/financeiro/geral',
          component: () => import('@/components/views/monitor/financeiro/geral/ListagemMonitorGeral')
        },
        {
          path: '/monitor/financeiro/apurado',
          component: () => import('@/components/views/monitor/financeiro/apurado/ListagemMonitorApurado')
        },
        // MINCETUR
        {
          path: '/mincetur/reportesGenerales/cuentaDelJugador',
          name: 'cuentaDelJugador',
          component: () => import('@/components/views/mincetur/geral/cuentaDelJugador.vue')
        },
        {
          path: '/mincetur/reportesGenerales/plataformaDeApuestas',
          name: 'plataformaDeApuestas',
          component: () => import('@/components/views/mincetur/geral/plataformaDeApuestas.vue')
        },
        {
          path: '/mincetur/reportesGenerales/depositosdelJugador',
          name: 'depositosdelJugador',
          component: () => import('@/components/views/mincetur/geral/depositosdelJugador.vue')
        },
        {
          path: '/mincetur/reportesGenerales/saquesPorjogador',
          name: 'saquesPorjogador',
          component: () => import('@/components/views/mincetur/geral/saquesPorjogador.vue')
        },
        {
          path: '/mincetur/reportesGenerales/reporteIngresosConsolidados',
          name: 'reporteIngresosConsolidados',
          component: () => import('@/components/views/mincetur/geral/reporteIngresosConsolidados.vue')
        },
        {
          path: '/mincetur/reportesGenerales/checksCritical',
          name: 'checksCritical',
          component: () => import('@/components/views/mincetur/geral/checksCritical.vue')
        },
        {
          path: '/mincetur/reportesGenerales/eventosSignificativos',
          name: 'eventosSignificativos',
          component: () => import('@/components/views/mincetur/geral/eventosSignificativos.vue')
        },
        {
          path: '/mincetur/reportesGenerales/datosEconomicos',
          name: 'datosEconomicos',
          component: () => import('@/components/views/mincetur/geral/datosEconomicos.vue')
        },
        {
          path: '/mincetur/reportesGenerales/datosTecnicos',
          name: 'datosTecnicos',
          component: () => import('@/components/views/mincetur/geral/datosTecnicos.vue')
        },
        {
          path: '/mincetur/sportsbook/apuestasDelJugador',
          name: 'apuestasDelJugador',
          component: () => import('@/components/views/mincetur/sportsbook/apuestasDelJugador.vue')
        },
        {
          path: '/mincetur/sportsbook/detalleApuestas',
          name: 'detalleApuestas',
          component: () => import('@/components/views/mincetur/sportsbook/detalleApuestas.vue')
        },
        {
          path: '/mincetur/sportsbook/ingresosPorEvento',
          name: 'ingresosPorEvento',
          component: () => import('@/components/views/mincetur/sportsbook/ingresosPorEvento.vue')
        },
        {
          path: '/mincetur/sportsbook/eventosFuturos',
          name: 'eventosFuturos',
          component: () => import('@/components/views/mincetur/sportsbook/eventosFuturos.vue')
        },
        {
          path: '/mincetur/casino/rendimientoDeJuego',
          name: 'rendimientoDeJuego',
          component: () => import('@/components/views/mincetur/casino/rendimientoDeJuego.vue')
        },
        {
          path: '/mincetur/casino/apuestasDelJugadorCasino',
          name: 'apuestasDelJugadorCasino',
          component: () => import('@/components/views/mincetur/casino/apuestasDelJugador.vue')
        },
        {
          path: '/mincetur/casino/sumarioDeJackpots',
          name: 'sumarioDeJackpots',
          component: () => import('@/components/views/mincetur/casino/sumarioDeJackpots.vue')
        }
      ]
    },
    {
      path: '*',
      get component() {
        return configUser ? layout.menu[configUser] : layout.menu['default'];
      },
      children: [
        {
          path: '*',
          component: () => import('@/layout/PageNotFound')
        }
      ]
    }
  ]
});

router.afterEach(() => {
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }
  globals.data().scrollTop(0, 0);
});

router.beforeEach((to, from, next) => {
  if (mfaRequiredRoutes.includes(to.name) && !localStorage.getItem('mfa-accomplished')) {
    next(from.path);
    return;
  }

  if (rootRequiredRoutes.includes(to.name) && !getUserIsRoot) {
    next(from.path);
    return;
  }

  document.body.classList.add('app-loading');
  setTimeout(() => next(), 10);
});

export default router;
